<div class="modals-currencies" [class.modals-currencies-show]="isModalsCurrenciesShow">
  <div class="modals-currencies-size">
    <span class="modals-currency">Курс:</span>
    <span class="modals-uah">1 EUR = {{ exchangeRatesEUR }} UAH.</span><br>
    <span class="modals-usd">1 EUR = {{ exchangeRatesUSD }} USD.</span>
  </div>
  <div class="list-cur" *ngFor="let itemCurrency of getCurrencies">
    <div class="item-cur" (click)="getCurrency(itemCurrency.id)"><a
      class="currency-{{itemCurrency.id}}">{{ itemCurrency.name }}</a></div>
  </div>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
